import baguetteBox from 'baguettebox.js'

const createBaguette = () => {
  baguetteBox.run('.baguette', {
    noScrollbars: true
  })
}

export default createBaguette
